import { render, staticRenderFns } from "./ClientViewSidebarGeneralInfo.vue?vue&type=template&id=3493f1da&scoped=true"
import script from "./ClientViewSidebarGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarGeneralInfo.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarGeneralInfo.vue?vue&type=style&index=0&id=3493f1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493f1da",
  null
  
)

export default component.exports